import { Button, Drawer, Form, Input, Radio, Select, Spin, notification } from 'antd';
import React, { useEffect, useState } from 'react'
import { buyACourse, getAllCoursesByRole } from '../../../../../../Constants/Api/functions/function';
import { useSelector } from 'react-redux';

const { Option } = Select;

const AddUserCourse = ({ setOpen, isOpen, handleGetUserCources, userId, userCources }) => {
    const [form] = Form.useForm(); // Add form instance
    const [isLoading, setIsLoading] = useState(false)
    const [api, contextHolder] = notification.useNotification();
    const [isAddToPayments, setIsAddToPayments] = useState(false)
    const [courses, setCourses] = useState([])
    const [newCourses, setNewCourses] = useState([])
    const [selectedCourse, setSelectedCourse] = useState(null)
    const allCources = useSelector(state => state.allCources.allCources);
    const userProfile = useSelector(state => state.userProfile.userProfile);

    useEffect(() => {
        hadleGetCources();
    }, [userCources, isOpen]);

    useEffect(() => {
        if (courses?.length > 0 && userCources?.length > 0) {
            const newCourses = courses.filter(course => !userCources.find(userCourse => userCourse.id === course.id));

            setNewCourses(newCourses)
        } else {
            setNewCourses(courses)
        }
    }, [courses, userCources, isOpen]);

    // Reset form when drawer is closed or opened
    useEffect(() => {
        if (!isOpen) {
            form.resetFields();
            setIsAddToPayments(false);
            setSelectedCourse(null);
        }
    }, [isOpen, form]);

    const hadleGetCources = async () => {
        setIsLoading(true);
        if (userProfile) {
            const response = await getAllCoursesByRole(userProfile.role, userProfile.id);
            if (response) {
                setCourses(response);
            }
        }
        setIsLoading(false);
    }


    const onFinish = async (values) => {
        setIsLoading(true)

        if (values.isAddToPayments) {
            values.amount = parseInt(values.paymentAmount);
        } else {
            values.isPaid = false;
            values.isAddToPayments = false;
            values.payedInstallments = values.payedInstallments || 0;
        }

        values.userId = userId;

        try {
            const response = await buyACourse(values);
            if (response) {
                handleGetUserCources();
                api.success({
                    message: 'User added to course'
                })
                // Reset form after successful submission
                form.resetFields();
                setIsAddToPayments(false);
                setSelectedCourse(null);
                setOpen(false);
            }
        } catch (error) {
            console.error('onFinish', error);
            api.error({
                message: 'Failed to add user to course'
            })
        }
        setIsLoading(false)
    }

    return (
        <div>
            {contextHolder}
            <Drawer
                title="Add Course to User"
                width={720}
                onClose={() => setOpen(false)}
                open={isOpen}
                styles={{
                    body: {
                        paddingBottom: 80,
                    },
                }}
            >
                <Spin
                    spinning={isLoading}
                    tip="Please wait..."
                >
                    <Form
                        form={form} // Link form instance
                        layout="vertical"
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name='courseId'
                            label='Course'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select course'
                                },
                            ]}
                        >
                            <Select
                                placeholder='Select course'
                                onChange={(value) => {
                                    const course = newCourses.find(c => c.id === value);
                                    setSelectedCourse(course);
                                }}
                            >
                                {newCourses?.map(course => (
                                    <Option key={course.id} value={course.id}>{course.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name='isAddToPayments'
                            label='Add to payments'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select add to payments'
                                },
                            ]}
                        >
                            <Radio.Group
                                onChange={(e) => setIsAddToPayments(e.target.value)}
                            >
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                            </Radio.Group>
                        </Form.Item>

                        {isAddToPayments && <>
                            <Form.Item
                                name='isPaid'
                                label='Is Paid'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select is paid'
                                    },
                                ]}
                            >
                                <Radio.Group>
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                name='paymentStatus'
                                label='Payment Status'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select payment status'
                                    },
                                ]}
                            >
                                <Radio.Group>
                                    <Radio value='pending'>Pending</Radio>
                                    <Radio value='paid'>Completed</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                name='paymentAmount'
                                label='Payment Amount'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter payment amount'
                                    },
                                ]}
                            >
                                <Input
                                    type='number'
                                    placeholder='Enter payment amount'
                                />
                            </Form.Item>

                            <Form.Item
                                name='paymentMethod'
                                label='Payment Method'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select payment method'
                                    },
                                ]}
                            >
                                <Select
                                    placeholder='Select payment method'
                                >
                                    <Option value='cash'>Cash</Option>
                                    <Option value='card'>Card</Option>
                                    <Option value='bank'>Bank</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item
                                name='payedInstallments'
                                label='Paid Installments'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select paid installments'
                                    },
                                ]}
                            >
                                <Select
                                    placeholder='Select paid installments'
                                >
                                    {Array.from({ length: (selectedCourse?.installments || 0) + 1 }, (_, i) => (
                                        <Option key={i} value={i}>{i}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </>}

                        <Form.Item>
                            <Button
                                type='primary'
                                htmlType='submit'
                                style={{ marginRight: 8 }}
                            >
                                Add User
                            </Button>
                            <Button
                                onClick={() => {
                                    form.resetFields();
                                    setIsAddToPayments(false);
                                    setSelectedCourse(null);
                                }}
                            >
                                Clear Form
                            </Button>
                        </Form.Item>
                    </Form>
                </Spin>
            </Drawer>
        </div>
    )
}

export default AddUserCourse